module.exports = __webpack_public_path__ + "img/图片11.b108a129.png";